import type { SortingState } from '@tanstack/react-table'

export type SystemDocumentOrdering = {
  field: string
  key?: string
  descending?: boolean
  cast?: string
}

const ID_TIEBREAKER: SystemDocumentOrdering = { field: 'id' }

const SORT_ID_TO_DATA_KEY: Record<string, { key: string; cast?: string }> = {
  title: { key: 'title' },
  documentTitle: { key: 'document_title' },
  system: { key: 'system' },
  drawing: { key: 'drawing_number' },
  vendor: { key: 'vendor_name' },
  docType: { key: 'document_type' },
  numPages: { key: 'total_pages', cast: 'int' },
  revisionCode: { key: 'revision_code' },
  revisionDate: { key: 'revision_date' },
}

export function mapSortingToOrderBy(
  sorting: SortingState | undefined
): SystemDocumentOrdering[] {
  const orderBy: SystemDocumentOrdering[] = []
  for (const { id, desc } of sorting ?? []) {
    const mapped = SORT_ID_TO_DATA_KEY[id]
    if (!mapped) continue
    orderBy.push({
      field: 'data',
      key: mapped.key,
      descending: desc,
      ...(mapped.cast ? { cast: mapped.cast } : {}),
    })
  }
  return orderBy
}

export function withIdTiebreaker(
  orderBy: SystemDocumentOrdering[]
): SystemDocumentOrdering[] {
  const hasIdOrdering = orderBy.some(
    (ordering) => ordering.field === 'id' && ordering.key === undefined
  )
  return hasIdOrdering ? orderBy : [...orderBy, ID_TIEBREAKER]
}
